/// <amd-module name="SuiteCommerce.PagePrinter.ItemDetailsLayout.CheckCrossHelper"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.PagePrinter.ItemDetailsLayout.CheckCrossHelper", ["require", "exports", "SuiteCommerce.PagePrinter.ItemDetailsLayout.Helper"], function (require, exports, ItemDetailsLayout_Helper_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var CheckCrossHelper = /** @class */ (function (_super) {
        __extends(CheckCrossHelper, _super);
        function CheckCrossHelper() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        CheckCrossHelper.prototype.prepareHelpers = function () {
            this.helpers = [
                {
                    name: 'getFormattedCheckCross',
                    helperAction: function (item, field) {
                        var fieldValue = item.get(field.fieldId);
                        return fieldValue
                            ? '<i class="check-icon"></i>'
                            : '<i class="cross-icon"></i>';
                    },
                },
                {
                    name: 'isCheckCross',
                    helperAction: function (fieldType) {
                        return fieldType === 'Check/Cross';
                    },
                },
            ];
        };
        return CheckCrossHelper;
    }(ItemDetailsLayout_Helper_1.Helper));
    exports.CheckCrossHelper = CheckCrossHelper;
});
